import React, { useState } from "react";
import "react-quill/dist/quill.snow.css";
import PlusIconBtn from "../../../Common/PlusIconBtn";
import ReactQuillEditor from "../../../Common/ReactQuillEditor";
import AddVariableModal from "../../../Model/AddVariableModal";

const EmailTab = ({
  isTabSelected,
  formData,
  formError,
  handleChange,
  assistantId,
  setFormData,
  isMetaAssistant,
}) => {
  const [addVariableModalVisible, setAddVariableModalVisible] = useState({
    variableFor: null,
    visible: false,
  });

  const onSubmitAddVariable = (variable) => {
    setFormData((p) => ({
      ...p,
      email: {
        ...p.email,
        [addVariableModalVisible.variableFor]:
          typeof p.email[addVariableModalVisible.variableFor] == "string"
            ? p.email[addVariableModalVisible.variableFor] + variable
            : p.email[addVariableModalVisible.variableFor],
      },
    }));
    setAddVariableModalVisible({
      visible: false,
      variableFor: null,
    });
  };

  return (
    <div
      className={
        isTabSelected
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      {addVariableModalVisible?.visible ? (
        <AddVariableModal
          assistantId={assistantId}
          onSubmit={onSubmitAddVariable}
          onClose={() =>
            setAddVariableModalVisible({
              variableFor: null,
              visible: false,
            })
          }
        />
      ) : null}

      <div className="formRow">
        <div className="formCol">
          <div className="form__Field">
            <label for="subject" className="form__label form__label--flex">
              Subject
              {!isMetaAssistant ? (
                <PlusIconBtn
                  onClick={() =>
                    setAddVariableModalVisible({
                      variableFor: "subject",
                      visible: true,
                    })
                  }
                />
              ) : null}
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              maxLength={100}
              onChange={handleChange}
              value={formData.subject}
              className="form__input form__input--sm"
              placeholder="Subject"
            />
            <div className="form__error">{formError.subjectError}</div>
          </div>
        </div>
      </div>
      <div className="formRow">
        <div className="formCol">
          <div className="form__Field">
            <label for="description" className="form__label form__label--flex">
              Message
              {!isMetaAssistant ? (
                <PlusIconBtn
                  onClick={() =>
                    setAddVariableModalVisible({
                      variableFor: "description",
                      visible: true,
                    })
                  }
                />
              ) : null}
            </label>
            <ReactQuillEditor
              id="description"
              name="description"
              theme="snow"
              value={formData.description}
              placeholder="Enter your message here..."
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  email: { ...prev?.email, description: value },
                }))
              }
            />
            {/* <textarea
              id="description"
              name="description"
              maxLength={500}
              onChange={handleChange}
              value={formData.description}
              className="form__textarea"
              placeholder="Enter your message here..."
            ></textarea> */}
            <div className="form__error">{formError.descriptionError}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTab;
